import algoliasearch from 'algoliasearch/lite';

// export const searchClient = algoliasearch(
//     "JWPIR4IC05",
//     "87c8bea112448d28be8ce7ee3e00bc61"
// );


const algoliaClient = algoliasearch(
    "JWPIR4IC05",
    "87c8bea112448d28be8ce7ee3e00bc61"
  );
  
  export const searchClient = {
    ...algoliaClient,
    search(requests) {
      if (requests.every(({ params }) => !params.query)) {
        return Promise.resolve({
          results: requests.map(() => ({
            hits: [],
            nbHits: 0,
            nbPages: 0,
            page: 0,
            processingTimeMS: 0,
            hitsPerPage: 0,
            exhaustiveNbHits: false,
            query: '',
            params: '',
          })),
        });
      }
  
      return algoliaClient.search(requests);
    },
  };
  